import { InternIconLink } from '../intern/icon-link';

/**
 * Model definition for Menu Link List
 */
export interface ContentMenuLinkList {
  id: string;
  headline?: string;
  items: InternIconLink[];
  __component: 'content.menu-link-list';
}

export function isContentMenuLinkList(obj: { __component?: string }): obj is ContentMenuLinkList {
  return obj.__component === 'content.menu-link-list';
}
